import { translations as visitDocumentTemplatesTranslations } from '~libs.desktop.shared.user-templates.forms';
import { translations as visitMedicalDocumentsDiagnosesTranslations } from '~libs.desktop.shared.visit-medical-documents.diagnoses';
import { translations as visitMedicalDocumentsProceduresTranslations } from '~libs.desktop.shared.visit-medical-documents.procedures';
import { translations as refundAdvancePaymentTranslations } from '~libs.desktop.shared.refund-advance-payment';
import { translations as appointmentsTimetableTranslations } from '~libs.shared.appointments-timetable';
import { translations as visitSettlementsTranslations } from '~libs.shared.visit-settlement';
import { translations as printFromVisitTranslations } from '~libs.desktop.shared.visit-medical-documents.print-from-visit';
import { translations as patientContactDataUpdateTranslations } from '~libs.desktop.shared.patient-contact-data-update';
import { translations as receptionServiceTranslations } from '~libs.shared.reception-service';
import { translations as visitEnterTranslations } from '~libs.desktop.shared.visit-enter';
import { translations as fieldsTranslations } from '~libs.desktop.shared.fields';
import { translations as patientEntitlementToMedicalServiceTranslations } from '~libs.desktop.patient-entitlement-to-medical-service';
import { translations as patientGroupsTranslations } from '~libs.desktop.shared.patient-groups';
import { translations as appointmentAdvancePaymentTranslations } from '~libs.desktop.shared.appointment-advance-payment';
import { translations as appointmentTranslations } from '~libs.desktop.shared.appointment';

import { translations as visitDocumentTemplateTranslations } from './features/documentTemplate/translations';
import { translations as visitConsentTemplateTranslations } from './features/consentTemplate/translations';
import { translations as electronicDocumentsTranslations } from './features/electronicDocuments/translations';
import medicalCertificate from './features/medicalCertificate';
import { translations as medicalDevicesTranslations } from './features/medicalDevices/translations';
import { prescriptionsHistoryTranslations } from './features/prescriptions';
import { translations as referralTranslations } from './features/referral/translations';
import { translations as educationalMaterialsTranslation } from './features/educationalMaterials/translations';
import visitReceptionService from './receptionService';
import { translations as visitTranslations } from './translations';
import visitSettlement from './visitSettlement';

export const translations = [
   visitTranslations,
   visitSettlement.translations,
   visitReceptionService.translations,
   medicalCertificate.translations,
   prescriptionsHistoryTranslations,
   medicalDevicesTranslations,
   referralTranslations,
   electronicDocumentsTranslations,
   visitMedicalDocumentsDiagnosesTranslations,
   visitMedicalDocumentsProceduresTranslations,
   visitDocumentTemplatesTranslations,
   visitDocumentTemplateTranslations,
   visitConsentTemplateTranslations,
   refundAdvancePaymentTranslations,
   appointmentsTimetableTranslations,
   appointmentTranslations,
   visitSettlementsTranslations,
   printFromVisitTranslations,
   patientContactDataUpdateTranslations,
   receptionServiceTranslations,
   visitEnterTranslations,
   fieldsTranslations,
   educationalMaterialsTranslation,
   patientEntitlementToMedicalServiceTranslations,
   patientGroupsTranslations,
   appointmentAdvancePaymentTranslations,
];

export { useAppointmentOutOfScheduleButton } from './appointment/buttons/AppointmentOutOfScheduleButton/AppointmentOutOfScheduleButton';
export { VisitsHistoryButton } from './appointment/buttons/VisitsHistoryButton';
export { ShowVisitButton } from './appointment/table/cells/OptionsCell/ShowVisitButton';
export { DosageTemplates, MagistralDrugTemplates } from './features/prescriptions';
export { PrescriptionVisitTemplates } from './prescriptionVisitTemplates/PrescriptionVisitTemplates';
export { useRedirectToAppointmentsList, useVisitModuleRouter } from './routes';
export { dispatchVisitDetailsCopyEvent } from './visit/form/VisitFormSynchronization.event';
export { useVisitsHistoryPanel } from './visitHistory/visitsHistory.hooks';
export { VisitTemplates } from './visitTemplates';
